import Icon from "@/components/Icon";
import Tag from "@/components/Tag";

export type Reviewer = {
  id: string;
  email: string;
  name: string;
};

interface ReviewerTagProps {
  reviewer: Reviewer;
  onRemove: (reviewer: Reviewer) => void;
}

export default function ReviewerTag({ reviewer, onRemove }: ReviewerTagProps) {
  return (
    <Tag tagType="outline" size="large">
      <div className="flex items-center gap-1">
        <span>{reviewer.name}</span>
        <div className="cursor-pointer" onClick={() => onRemove(reviewer)}>
          <Icon name="close" size={18} />
        </div>
      </div>
    </Tag>
  );
}
